import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/enquiry-one.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/enquiry-two.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/HandPickedWrapper1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/HandPickedWrapper2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/HandPickedWrapper3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/happy-customers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/hero-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/tariff.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/top-recommended.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/thailand/main-page/components/view-more.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Accordian/Accordian.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/button/button.scss");
;
import(/* webpackMode: "eager" */ "/app/components/heading/heading.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/svg/common/social-icons/whatsapp.svg");
;
import(/* webpackMode: "eager" */ "/app/sections/common/enquiry/enquiry.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/common/footer/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/common/footer/destination.tsx");
;
import(/* webpackMode: "eager" */ "/app/sections/common/meta/meta.scss");
;
import(/* webpackMode: "eager" */ "/app/sections/common/footer/footer.scss");
;
import(/* webpackMode: "eager" */ "/app/sections/common/faq/faq.scss");
